<template>
  <v-layout row wrap justify-center>
    <v-card class="shadow flex xs12 pa-0">
      <div
        class="
          py-1
          px-3
          secondary
          white--text
          font-weight-bold
          di-flex
          justify-center
          align-center
        "
      >
        <v-checkbox
          dark
          singleLine
          hideDetails
          color="primary"
          v-model="is_dab"
          title="Auction Results"
          style="max-width: 32px"
        />
        <span class="py-1">{{ $t("dab_auction") }}</span>
        <v-spacer />
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="white" class="py-0 ma-0" flat dark v-on="on">
                <!-- <v-icon class="mx-2">more_vert</v-icon> -->
                <strong class="mt-1"> {{ selected_currency.name }} </strong>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                :key="index"
                @click="currencyChanged(item)"
                v-for="(item, index) in currencies"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-card-text class="pt-3">
        <v-layout row wrap class="flex-row align-center justify-center">
          <v-checkbox
            singleLine
            hideDetails
            color="primary"
            @change="initData"
            v-model="filter_date"
            style="max-width: 24px"
          />
          <v-date
            singleLine
            :hideDetails="true"
            :clearable="true"
            @input="initData"
            format="YYYY-MM-DD"
            v-model="start_date"
            value-type="YYYY-MM-DD"
            input_id="start_date_expo"
            :placeholder="$t('start_date')"
            :disabled="!filter_date && !loading"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            v-model="end_date"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            input_id="end_date_expo"
            :placeholder="$t('end_date')"
            :disabled="!filter_date && !loading"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-spacer />
          <v-text-field
            outline
            hide-details
            v-model="search"
            style="max-width: 420px"
            class="flex xs12 rounded"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            flat
            icon
            class="mx-0"
            @click="initData"
            :loading="loading"
            color="grey darken-2"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn
            icon
            flat
            class="mx-0"
            color="grey darken-2"
            @click="printTable(false)"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            class="mx-0"
            color="grey darken-2"
            @click="printTable(true)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-layout>

        <v-data-table
          ref="tbl"
          :items="items"
          :search="search"
          :loading="loading"
          :headers="headers"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{ index, item }">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <strong>
                  {{ smbl(item.sale_currency_id) }} -
                  {{ smbl(item.buy_currency_id) }}
                </strong>
              </td>
              <td>
                <strong>
                  {{
                    item.amount
                      | currency({ symbol: smbl(item.sale_currency_id) })
                  }}
                </strong>
              </td>
              <td colspan="2">
                <strong>
                  {{
                    item.exchanged_amount
                      | currency({ symbol: smbl(item.buy_currency_id) })
                  }}
                </strong>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr
              :key="key"
              class="font-weight-bold"
              v-for="(value, key) in summery.currencies"
            >
              <td colspan="2">{{ $t("total") }} {{ smbl(value) }}</td>
              <td class="lr--text px-3">
                {{ summery.amount[value] | currency({ symbol: smbl(value) }) }}
              </td>
              <td>
                {{
                  summery.exchanged_amount[value]
                    | currency({ symbol: smbl(value) })
                }}
              </td>
              <td
                colspan="100%"
                :class="{
                  'red--text': summery.exposed_amount[value] < 0,
                  'activeColor--text': summery.exposed_amount[value] > 0,
                }"
              >
                <span>
                  {{
                    summery.exposed_amount[value]
                      | currency({ symbol: smbl(value) })
                  }}
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
let currentTime = new Date();
import curjs from "currency.js";
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

export default {
  name: "ExposeReport",
  mixins: [customersMixin],
  props: {
    branch_id: { default: undefined },
    brnch_name: { default: "" },
  },
  data: () => ({
    search: "",
    items: [],
    dialog: false,
    editIndex: -1,
    loading: false,
    editDialog: false,
    selected_currency: {
      id: undefined,
      name: "ALl Currencies",
    },
    selected_type: {
      value: undefined,
      text: "All Types",
    },
    is_dab: false,
    start_date: null,
    filter_date: true,
    end_date: currentTime.toLocaleDateString("en-ca"),
  }),

  computed: {
    types() {
      return [
        {
          value: undefined,
          text: "All Types",
        },
        {
          text: "Sale",
          value: "sale",
        },
        {
          text: "Buy",
          value: "buy",
        },
        {
          text: "F2F",
          value: "f2f",
        },
      ];
    },

    currencies() {
      let items = this.initialData.currencies;
      return [{ id: undefined, name: "ALl Currencies" }, ...items];
    },
    summery() {
      let amount = {};
      let exchanged_amount = {};
      let exposed_amount = {};
      let currencies = {};

      this.items.forEach((item) => {
        //sum amounts by currency
        if (!amount[item.sale_currency_id]) amount[item.sale_currency_id] = 0;
        amount[item.sale_currency_id] =
          amount[item.sale_currency_id] + item.amount;

        // sum exchenges by currency
        if (!exchanged_amount[item.buy_currency_id])
          exchanged_amount[item.buy_currency_id] = 0;
        exchanged_amount[item.buy_currency_id] =
          exchanged_amount[item.buy_currency_id] + item.exchanged_amount;

        if (!exposed_amount[item.buy_currency_id])
          exposed_amount[item.buy_currency_id] = 0;
        exposed_amount[item.buy_currency_id] =
          exposed_amount[item.buy_currency_id] + item.exchanged_amount;

        if (!exposed_amount[item.sale_currency_id])
          exposed_amount[item.sale_currency_id] = 0;
        exposed_amount[item.sale_currency_id] =
          exposed_amount[item.sale_currency_id] - item.amount;

        // add amount or exchange currency to used list
        if (item.sale_currency_id)
          currencies[item.sale_currency_id] = item.sale_currency_id;
        if (item.buy_currency_id)
          currencies[item.buy_currency_id] = item.buy_currency_id;
      });
      return { amount, exchanged_amount, exposed_amount, currencies };
    },

    can() {
      return {
        add: this.userCan("add_exchanges"),
        view: this.userCan("view_exchanges"),
        edit: this.userCan("edit_exchanges"),
        delete: this.userCan("delete_exchanges"),
        any:
          this.userCan("edit_exchanges") ||
          this.userCan("view_exchanges") ||
          this.userCan("delete_exchanges"),
      };
    },

    headers: (vm) => {
      let items = [
        {
          value: "number",
          width: "30px",
          sortable: false,
          hidePrint: true,
          text: vm.$t("tr"),
        },
        {
          sortable: false,
          text: vm.$t("currency"),
          computed: (item) =>
            `${vm.smbl(item.sale_currency_id)} - ${vm.smbl(
              item.buy_currency_id
            )}`,
        },
        {
          sortable: false,
          value: "amount",
          text: vm.$t("sale_currency"),
          computed: (item) =>
            `${curjs(item.amount).format({ symbol: "" })} ${vm.smbl(
              item.sale_currency_id
            )}`,
        },
        {
          sortable: false,
          value: "exchanged_amount",
          text: vm.$t("buy_currency"),
          computed: (item) =>
            `${curjs(item.exchanged_amount).format({ symbol: "" })} ${vm.smbl(
              item.buy_currency_id
            )}`,
        },
        {
          sortable: false,
          class: "font-weight-bold",
          text: vm.$t("exposed_amount"),
          computed: (item) =>
            item.exposed_amount
              ? `${curjs(item.exposed_amount).format({ symbol: "" })} ${vm.smbl(
                  item.sale_currency_id
                )}`
              : "",
        },
      ];
      return items;
    },
  },
  methods: {
    initData() {
      this.loading = true;
      let { search, end_date, is_dab, branch_id, start_date, filter_date } =
        this;
      let params = {
        search,
        is_dab,
        end_date,
        branch_id,
        start_date,
        filter_date,
        type: this.selected_type.value,
        currency_id: this.selected_currency.id,
      };
      this.axios
        .get("reports?expose=true", { params })
        .then((resp) => {
          this.items = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    currencyChanged(item) {
      this.selected_currency = item;
      this.initData();
    },
    typeChanged(item) {
      this.selected_type = item;
      this.initData();
    },
    printTable(excel) {
      let items = this.$refs.tbl.filteredItems;
      for (let currency in this.summery.currencies) {
        items.push({
          sale_currency_id: currency,
          amount: this.summery.amount[currency],
          exchanged_amount: this.summery.amount[currency],
          exposed_amount: this.summery.exposed_amount[currency],
        });
      }
      // items.puhs()
      let data = {
        items,
        brnch_name: this.brnch_name,
        headers: this.headers.filter((x) => !x.hidePrint),
        title: `DAB Auction Results from ${this.start_date} to ${this.end_date}`,
      };

      if (excel)
        return this.xl_tables(data, "DAB‌ Auction", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },

  created() {
    this.initData();
  },

  watch: {
    branch_id: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    is_dab: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    search: debounce(function (newVal) {
      this.initData(newVal);
    }, 1000),
  },
};
</script>
